const yesno = value => value ? 'Yes' : 'No'

export default {
  yesno
}



// WEBPACK FOOTER //
// ./src/filters/booleans.js